import { useMutation } from '@apollo/react-hooks';
import {
  AcknowledgeAlertMutation,
  AcknowledgeAlertMutation_acknowledgeAlert_alert,
  AcknowledgeAlertMutationVariables
} from './__generated__/AcknowledgeAlertMutation';
import { kmsClient } from 'api';
import { ACKNOWLEDGE_ALERT } from './alertAcknowledge.mutation';

type MutationProps = {
  onStart?: () => void;
  onCompleted?: (alert: AcknowledgeAlertMutation_acknowledgeAlert_alert) => void;
  onError?: (errors: string[]) => void;
};

export const useAcknowledgeAlert = ({ onStart, onCompleted, onError }: MutationProps) => {
  const [acknowledgeAlert] = useMutation<AcknowledgeAlertMutation, AcknowledgeAlertMutationVariables>(
    ACKNOWLEDGE_ALERT,
    {
      client: kmsClient,
      onCompleted: (data) => {
        if (data.acknowledgeAlert?.errors?.length) {
          if (onError) onError(data.acknowledgeAlert.errors);
        } else {
          if (onCompleted && data.acknowledgeAlert?.alert) onCompleted(data.acknowledgeAlert.alert);
        }
      },
      onError: (error) => onError && onError([error.message])
    }
  );
  return (variables: AcknowledgeAlertMutationVariables) => {
    if (onStart) onStart();
    acknowledgeAlert({ variables });
  };
};
